<mp-action-button [icon]="icon()" [disabled]="disabled()" (buttonClick)="emitClick()">
  <mat-slide-toggle
    class="actions-slide-toggle"
    [class.actions-slide-toggle--disabled]="disabled()"
    labelPosition="before"
    [hideIcon]="true"
    [checked]="checked()"
    [disableRipple]="true"
    [disabled]="disabled()"
  >
    <span class="actions-slide-toggle__label">{{ label() }}</span>
  </mat-slide-toggle>
</mp-action-button>
